import { Kanban, Users, CheckCircle2, Clock } from "lucide-react";
import { PageHeader } from "@/components/dashboard/ui";

const COLS = [
  { title: "New Lead", items: ["Priya Sharma — Wedding enquiry", "TechNova — Corporate gala"], color: "border-gold/30" },
  { title: "Contacted", items: ["Arjun Mehta — Engagement"], color: "border-blue-400/30" },
  { title: "Proposal Sent", items: ["Golden Hour Co — Studio plan"], color: "border-orange-400/30" },
  { title: "Won", items: ["Rahul Photography — Professional"], color: "border-emerald-400/30" },
];

export default function AdminCRM() {
  return (
    <div>
      <PageHeader title="CRM Pipeline" subtitle="Manage studio & client relationships end-to-end." />
      <div className="rounded-xl border border-gold/20 bg-gradient-to-r from-gold/5 to-transparent p-4 mb-6 flex items-center gap-3">
        <Clock className="w-5 h-5 text-gold" /><span className="text-sm text-secondary-foreground">Preview of the upcoming CRM. Full pipeline automation, tasks & email sync are coming soon.</span>
      </div>
      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4">
        {COLS.map((c) => (
          <div key={c.title} className="rounded-2xl border border-border bg-black/40 p-4">
            <div className="flex items-center justify-between mb-3"><span className="text-white text-sm font-medium">{c.title}</span><span className="text-xs text-muted-foreground">{c.items.length}</span></div>
            <div className="space-y-2">
              {c.items.map((i) => (
                <div key={i} className={`rounded-lg border ${c.color} bg-white/[0.03] p-3 text-sm text-secondary-foreground`}>{i}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
